function PushIcon(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
      fill="currentColor"
      {...props}
    >
      <g transform="translate(0,512) scale(0.1,-0.1)" stroke="none">
        <path
          d="M2455 5106 c-84 -21 -147 -57 -211 -121 -103 -103 -134 -195 -134
-403 l0 -127 -78 -29 c-470 -174 -829 -559 -963 -1036 -47 -164 -50 -208 -59
-680 -9 -492 -14 -555 -71 -790 -62 -253 -175 -510 -322 -732 -64 -97 -122
-171 -271 -343 -60 -70 -38 -183 44 -225 38 -19 57 -20 738 -20 l700 0 6 -34
c26 -139 148 -319 286 -421 61 -45 171 -98 250 -121 81 -23 278 -26 360 -5
252 63 461 255 537 492 l28 89 698 0 c679 0 699 1 737 20 26 13 47 34 60 60
38 74 23 127 -59 215 -255 273 -458 650 -550 1025 -57 232 -63 297 -71 790 -9
473 -12 515 -59 681 -133 475 -509 876 -973 1040 l-68 24 0 127 c0 207 -31
300 -135 404 -112 113 -269 158 -420 120z m175 -306 c60 -31 80 -78 80 -192
l0 -93 -150 0 -150 0 0 95 c1 112 16 150 76 186 48 29 92 30 144 4z m110 -595
c144 -22 233 -50 365 -114 353 -173 592 -480 680 -871 14 -61 19 -161 25 -530
7 -380 11 -476 28 -585 64 -406 199 -759 415 -1082 39 -59 74 -111 75 -115 2
-5 -794 -8 -1768 -8 -974 0 -1770 3 -1768 8 2 4 36 56 75 115 215 322 352 680
415 1081 17 109 21 207 28 586 6 369 11 469 25 530 56 250 168 455 344 631
111 110 213 182 355 250 219 104 468 141 706 104z m240 -3611 c0 -25 -73 -134
-115 -172 -175 -160 -431 -162 -606 -5 -47 43 -101 119 -114 161 l-6 22 420 0
c232 0 421 -3 421 -6z"
        />
        <path
          d="M996 4581 c-32 -22 -154 -154 -221 -241 -251 -326 -417 -749 -454
-1160 -16 -174 -14 -234 9 -280 23 -45 80 -80 130 -80 88 0 150 74 150 179 0
89 18 254 41 366 63 312 228 645 435 878 128 143 134 153 134 211 0 57 -21 97
-66 127 -39 26 -119 25 -158 0z"
        />
        <path
          d="M3966 4581 c-45 -30 -66 -70 -66 -128 0 -57 2 -60 138 -215 206 -234
369 -564 431 -873 23 -112 41 -277 41 -366 0 -105 62 -179 150 -179 50 0 107
35 130 80 23 45 25 107 10 275 -39 420 -210 853 -464 1175 -79 100 -173 203
-208 228 -42 29 -120 30 -162 3z"
        />
      </g>
    </svg>
  );
}

export default PushIcon;
